'use client';

import { CompanyLogo } from '@componentsroot/CompanyLogo';
import { Stack, Theme, Typography } from '@mui/material';
import { withClarityTheme } from '@verifime/styles';
import { ReactNode } from 'react';

interface CompanyLogoAndNameProps {
  readonly companyName?: string;
  readonly companyLogoUrl?: string;
  readonly companyNameLabel?: ReactNode;
}

function CompanyLogoAndNameComponent({
  companyName,
  companyLogoUrl,
  companyNameLabel,
}: CompanyLogoAndNameProps) {
  if (!companyName && !companyLogoUrl) {
    return null;
  }
  return (
    <Stack
      direction="column"
      gap={(theme: Theme) => theme.semantic.spacing.sm}
      alignItems="center"
      justifyContent="center"
    >
      {companyLogoUrl && <CompanyLogo companyName={companyName} companyLogoUrl={companyLogoUrl} />}

      {companyName && (
        <Stack
          direction={['column', 'row']}
          sx={{ wordBreak: 'break-word' }}
          gap={(theme: Theme) => theme.semantic.spacing.xs}
          alignItems="center"
          justifyContent="center"
        >
          {companyNameLabel}
          <Typography variant="h6" textAlign="center" data-record-company-name={companyName}>
            {companyName}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}

export const CompanyLogoAndName = withClarityTheme(CompanyLogoAndNameComponent);
